import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Plus2 = (props) => (
  <Icon viewBox="0 0 31 31" {...props}>
    <g>
      <title>upload-logo</title>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M.5 16H31v-1H0v1z" />
        <path d="M15 .5V31h1V0h-1z" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Plus2;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Plus2.js